import { LAB_REPORT } from "@/api_framework/api_config";
import {
  ILabReportInterpretationEMR,
  ILabReportInterpretationEMRDetailResponse,
} from "@/api_framework/api_modals/LabReportInterpretation";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";

AxiosCurlirize(axios, () => {});

export const useLabReportInterpretationEMRDetailAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const execute = useCallback(async (emrId: string): Promise<ILabReportInterpretationEMR | null> => {
    setLoading(true);
    setError(false);
    const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
    return axios
      .get(LAB_REPORT.LAB_REPORT_INTERPRETATION_EMR_DETAIL.baseURL, {
        params: { emr_id: emrId },
        headers: {
          Authorization: `${accessToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((res: AxiosResponse<ILabReportInterpretationEMRDetailResponse>) => {
        const data = res.data?.status === true ? res.data.data : null;
        if (!data) setError(true);
        return data;
      })
      .catch((e: AxiosError) => {
        sendCurl(e.config?.["curlCommand"]);
        captureError(e);
        setError(true);
        return null;
      })
      .finally(() => setLoading(false));
  }, []);

  return { execute, loading, error };
};
